import { plainToClass } from "class-transformer";
import { DocumentTree, DocumentTreeV2 } from "../document-tree/document-tree.objects";
import { DocumentTreeLoaderV2, DocumentTreeLoaderWithSharepoint, DocumentTreeCollabLoader } from "../document-tree/document-tree-loader";


export class DocumentLibraryLoader {

    constructor(modelJson: any, requiredDialogId: string = "") {
        $(() => {

            let model: DocumentLibraryModel = plainToClass(DocumentLibraryModel, <DocumentLibraryModel>modelJson);
            model.DocumentSections = plainToClass(DocumentSection, <DocumentSection[]>model.DocumentSections);

            //console.log(model);

            model.DocumentSections.forEach((section: DocumentSection) => {
                new DocumentTree(JSON.parse(section.DocumentsJson), section.TreeId, section.SearchBoxId, section.SearchClearId);                
            });

            if (requiredDialogId != "") {
                $("#" + requiredDialogId).modal({
                    backdrop: 'static',
                    keyboard: false
                });
                $("#" + requiredDialogId).modal('show');
            }

            // Open + Close Document Repos
            $(".card-header").on('click', function () {

                if ($(this).hasClass("active-files")) {
                    $(this).removeClass("active-files");

                    $(this).find(".arrow-down").addClass("d-none");
                    $(this).find(".arrow-right").removeClass("d-none");
                }

                else {
                    // Deactivate section dropdowns
                    let parentEl = $(this).closest(".accordion-section");
                    parentEl.find(".card-header").removeClass("active-files");
                    parentEl.find(".arrow-down").addClass("d-none");
                    parentEl.find(".arrow-right").removeClass("d-none");

                    // Activate this dropdown
                    $(this).addClass("active-files");

                    $(this).find(".arrow-right").addClass("d-none");
                    $(this).find(".arrow-down").removeClass("d-none");
                }

            });
        });
    }
}

export class DocumentLibraryLoaderV2 {

    constructor(modelJson: any, requiredDialogId: string = "", targetFile: string = "", targetSearchBox: string = "") {
        $(() => {
            targetFile = HtmlDecoder.DecodeHtml(targetFile);
            targetSearchBox = HtmlDecoder.DecodeHtml(targetSearchBox);

            let model: DocumentLibraryModel = plainToClass(DocumentLibraryModel, <DocumentLibraryModel>modelJson);
            model.DocumentSections = plainToClass(DocumentSection, <DocumentSection[]>model.DocumentSections);

            //console.log(model);

            model.DocumentSections.forEach((section: DocumentSection) => {
                new DocumentTreeLoaderV2(JSON.parse(section.DocumentsJson), section.TreeId, section.SearchBoxId, section.SearchClearId, targetFile, targetSearchBox);
            });

            if (requiredDialogId != "") {
                $("#" + requiredDialogId).modal({
                    backdrop: 'static',
                    keyboard: false
                });
                $("#" + requiredDialogId).modal('show');
            }

            // Open + Close Document Repos
            $(".card-header").on('click', function () {

                if ($(this).hasClass("active-files")) {
                    $(this).removeClass("active-files");

                    $(this).find(".arrow-down").addClass("d-none");
                    $(this).find(".arrow-right").removeClass("d-none");
                }

                else {
                    // Deactivate section dropdowns
                    let parentEl = $(this).closest(".accordion-section");
                    parentEl.find(".card-header").removeClass("active-files");
                    parentEl.find(".arrow-down").addClass("d-none");
                    parentEl.find(".arrow-right").removeClass("d-none");

                    // Activate this dropdown
                    $(this).addClass("active-files");

                    $(this).find(".arrow-right").addClass("d-none");
                    $(this).find(".arrow-down").removeClass("d-none");
                }

            });

            // Remove the iframe information when the modal is closed
            $("#view-document-modal").on("hidden.bs.modal", () => {
                $("#view-document-modal").find("#document-iframe").attr("src", "");
            })
        });
    }
}

export class DocumentLibraryLoaderWithSharepoint {

    constructor(modelJson: any, isCollab: boolean, requiredDialogId: string = "", targetFile: string = "", targetSearchBox: string = "") {
        $(() => {

            targetFile = HtmlDecoder.DecodeHtml(targetFile);
            targetSearchBox = HtmlDecoder.DecodeHtml(targetSearchBox);
            
            let model: DocumentLibrarySharepointModel = plainToClass(DocumentLibrarySharepointModel, <DocumentLibrarySharepointModel>modelJson);
            model.DocumentSections = plainToClass(DocumentSectionSharepoint, <DocumentSectionSharepoint[]>model.DocumentSections);

            //console.log(model);

            model.DocumentSections.forEach((section: DocumentSectionSharepoint) => {
                new DocumentTreeLoaderWithSharepoint(JSON.parse(section.DocumentsJson), JSON.parse(section.SharepointFileMapping), section.S3FolderPrefix, isCollab, section.TreeId, section.SearchBoxId, section.SearchClearId, targetFile, targetSearchBox);
            });

            if (requiredDialogId != "") {
                $("#" + requiredDialogId).modal({
                    backdrop: 'static',
                    keyboard: false
                });
                $("#" + requiredDialogId).modal('show');
            }

            // Open + Close Document Repos
            $(".card-header").on('click', function () {

                if ($(this).hasClass("active-files")) {
                    $(this).removeClass("active-files");

                    $(this).find(".arrow-down").addClass("d-none");
                    $(this).find(".arrow-right").removeClass("d-none");
                }

                else {
                    // Deactivate section dropdowns
                    let parentEl = $(this).closest(".accordion-section");
                    parentEl.find(".card-header").removeClass("active-files");
                    parentEl.find(".arrow-down").addClass("d-none");
                    parentEl.find(".arrow-right").removeClass("d-none");

                    // Activate this dropdown
                    $(this).addClass("active-files");

                    $(this).find(".arrow-right").addClass("d-none");
                    $(this).find(".arrow-down").removeClass("d-none");
                }

            });

            // Remove the iframe information when the modal is closed
            $("#view-document-modal").on("hidden.bs.modal", () => {
                $("#view-document-modal").find("#document-iframe").attr("src", "");
            })
        });
    }
}

export class DocumentLibraryLoaderWithSharepointNoDialog {

    constructor(modelJson: any, isCollab: boolean, targetFile: string = "", targetSearchBox: string = "") {
        $(() => {

            targetFile = HtmlDecoder.DecodeHtml(targetFile);
            targetSearchBox = HtmlDecoder.DecodeHtml(targetSearchBox);

            let model: DocumentLibrarySharepointModel = plainToClass(DocumentLibrarySharepointModel, <DocumentLibrarySharepointModel>modelJson);
            model.DocumentSections = plainToClass(DocumentSectionSharepoint, <DocumentSectionSharepoint[]>model.DocumentSections);

            //console.log(model);

            model.DocumentSections.forEach((section: DocumentSectionSharepoint) => {
                new DocumentTreeLoaderWithSharepoint(JSON.parse(section.DocumentsJson), JSON.parse(section.SharepointFileMapping), section.S3FolderPrefix, isCollab, section.TreeId, section.SearchBoxId, section.SearchClearId, targetFile, targetSearchBox);
            });

           /* if (requiredDialogId != "") {
                $("#" + requiredDialogId).modal({
                    backdrop: 'static',
                    keyboard: false
                });
                $("#" + requiredDialogId).modal('show');
            }*/

            // Open + Close Document Repos
            $(".card-header").on('click', function () {

                if ($(this).hasClass("active-files")) {
                    $(this).removeClass("active-files");

                    $(this).find(".arrow-down").addClass("d-none");
                    $(this).find(".arrow-right").removeClass("d-none");
                }

                else {
                    // Deactivate section dropdowns
                    let parentEl = $(this).closest(".accordion-section");
                    parentEl.find(".card-header").removeClass("active-files");
                    parentEl.find(".arrow-down").addClass("d-none");
                    parentEl.find(".arrow-right").removeClass("d-none");

                    // Activate this dropdown
                    $(this).addClass("active-files");

                    $(this).find(".arrow-right").addClass("d-none");
                    $(this).find(".arrow-down").removeClass("d-none");
                }

            });

            // Remove the iframe information when the modal is closed
            $("#view-document-modal").on("hidden.bs.modal", () => {
                $("#view-document-modal").find("#document-iframe").attr("src", "");
            })
        });
    }
}


export class DocumentLibraryLoaderIsCollab {
    constructor(modelJson: any, targetFile: string = "", targetSearchBox: string = "") {
        $(() => {

            targetFile = HtmlDecoder.DecodeHtml(targetFile);
            targetSearchBox = HtmlDecoder.DecodeHtml(targetSearchBox);

            let model: DocumentLibraryModel = plainToClass(DocumentLibraryModel, <DocumentLibraryModel>modelJson);
            model.DocumentSections = plainToClass(DocumentSection, <DocumentSection[]>model.DocumentSections);

            //console.log(model);

            model.DocumentSections.forEach((section: DocumentSection) => {
                new DocumentTreeCollabLoader(JSON.parse(section.DocumentsJson), section.TreeId, section.SearchBoxId, section.SearchClearId, targetFile, targetSearchBox);
            });

            /* if (requiredDialogId != "") {
                 $("#" + requiredDialogId).modal({
                     backdrop: 'static',
                     keyboard: false
                 });
                 $("#" + requiredDialogId).modal('show');
             }*/

            // Open + Close Document Repos
            $(".card-header").on('click', function () {

                if ($(this).hasClass("active-files")) {
                    $(this).removeClass("active-files");

                    $(this).find(".arrow-down").addClass("d-none");
                    $(this).find(".arrow-right").removeClass("d-none");
                }

                else {
                    // Deactivate section dropdowns
                    let parentEl = $(this).closest(".accordion-section");
                    parentEl.find(".card-header").removeClass("active-files");
                    parentEl.find(".arrow-down").addClass("d-none");
                    parentEl.find(".arrow-right").removeClass("d-none");

                    // Activate this dropdown
                    $(this).addClass("active-files");

                    $(this).find(".arrow-right").addClass("d-none");
                    $(this).find(".arrow-down").removeClass("d-none");
                }

            });

            // Remove the iframe information when the modal is closed
            $("#view-document-modal").on("hidden.bs.modal", () => {
                $("#view-document-modal").find("#document-iframe").attr("src", "");
            })
        });
    }
}

export class HtmlDecoder {
    static DecodeHtml(encodedString: string): string {
        let regexArray: any[] = [
            [/(&quot;)/g, ""],
            [/(&amp;)/g, "&"],
            [/(&gt;)/g, ">"],
            [/(&lt;)/g, "<"]
        ]

        regexArray.forEach(char => {
            encodedString = encodedString.replace(char[0], char[1])
        })

        return encodedString;
    }
}

export class DocumentLibraryModel {
    Title: string;
    Description: string;
    //Images: string[];
    DocumentSections: DocumentSection[];
}

export class DocumentSection {
    Label: string;
    DocumentsJson: string;
    TreeId: string;
    SearchBoxId: string;
    SearchClearId: string;
}

export class DocumentLibrarySharepointModel {
    Title: string;
    Description: string;
    DocumentSections: DocumentSectionSharepoint[]
}

export class DocumentSectionSharepoint {
    Label: string;
    DocumentsJson: string;
    TreeId: string;
    SearchBoxId: string;
    SearchClearId: string;
    SharepointFileMapping: string; 
    S3FolderPrefix: string;
}
